import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import { fetchGymCityLocationData } from "../../redux/website-reducers/websiteSlice";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import {
  add_gym_location,
  delete_gym_location,
  map_gym_location,
  update_gym_location,
} from "../../data/ApiEndpoints";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { commonDeleteApi } from "../../redux/reducers/deleteApiSlice";
import SelectDropdown from "../components-react/SelectDropdown";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../data/APIs";

const MappedGyms = ({ userInfoData, rowData, closeModal, callFunction }) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { gymCityLocationLoading, gymCityLocationError, gymCityLocation } =
    useSelector((state) => state.webApi);
  const { postPutLoading } = useSelector((state) => state.common);

  const [allGymLocations, setAllGymLocations] = useState([]);
  const iniModvalues = {
    isMap: false,
    isEdit: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const forminitials = {
    locationName: "",
    isActive: false,
  };
  const [formValues, setFormValues] = useState(forminitials);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  function getGymLocations() {
    if (rowData?.city_id) {
      const filters = {
        city_id: rowData.city_id,
      };

      dispatch(
        fetchGymCityLocationData({
          filters: filters,
          token: userInfoData?.token,
        })
      );
    }
  }

  const onSubmit = (modname) => {
    if (modname === "add") {
      const userData = {
        location_name: formValues.locationName || "",
        city_id: rowData?.city_id || "",
        status: formValues.isActive ? "active" : "inactive",
      };

      if (modValues.isEdit) {
        userData.location_id = modValues.rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Confirm To Submit The Form!`,
        "Edit Form",
        "Submit Form"
      );
    } else if (modname === "map") {
      const userData = {
        gym_id: formValues.selectedGym?.value || "",
        location_id: modValues.rowData?.uid || "",
      };

      const handleConfirm = async () => {
        handleMapGym(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Confirm To Submit The Form!`,
        "Edit Form",
        "Submit Form"
      );
    }
  };

  const handleSubmitForm = async (payload) => {
    const method = modValues.isEdit ? "PUT" : "POST";
    const endpoint = modValues.isEdit ? update_gym_location : add_gym_location;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(forminitials);
        getGymLocations();
        setModValues(iniModvalues);
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleMapGym = async (payload) => {
    const method = "PUT";
    const endpoint = map_gym_location;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(forminitials);
        getGymLocations();
        setModValues(iniModvalues);
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: delete_gym_location,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
            getGymLocations();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete this!`);
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    getGymLocations();
  }, [rowData?.city_id]);

  useEffect(() => {
    if (
      !gymCityLocationLoading &&
      !gymCityLocationError &&
      gymCityLocation?.status &&
      gymCityLocation?.data?.length > 0
    ) {
      setAllGymLocations(gymCityLocation.data);
    } else {
      setAllGymLocations([]);
    }
  }, [gymCityLocationLoading, gymCityLocationError, gymCityLocation]);

  useEffect(() => {
    if (modValues.isEdit) {
      setFormValues((prevs) => ({
        ...prevs,
        locationName: modValues.rowData?.location
          ? modValues.rowData.location
          : "",
        isActive: modValues.rowData?.status === "active" ? true : false,
      }));
    } else if (modValues.isMap) {
      dispatch(fetchGymData(userInfoData?.token));
    }
  }, [modValues]);

  const tbColumns = [
    {
      dataField: "location",
      text: "location",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.location || "NA"}</span>;
      },
    },
    {
      dataField: "gym_id",
      text: "gym",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.gym_name || "NA"}</span>;
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27"
            style={{
              background: row?.status === "active" ? "#379C00" : "#D90000",
              color: "#fff",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            type="button"
            className="actionBtn"
            style={{
              opacity: "1",
              cursor: "pointer",
              background: "#2973B2",
              color: "#fff",
              borderRadius: "8px",
              fontSize: "15px",
              padding: "10px 15px",
              textTransform: "capitalize",
            }}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isMap: modValues.rowData?.uid === row?.uid ? false : true,
                modName: modValues.rowData?.uid === row?.uid ? "" : "map_gym",
                rowData: modValues.rowData?.uid === row?.uid ? "" : row,
                isEdit: false,
              }))
            }
          >
            map gym
          </button>
          <button
            type="button"
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isEdit: modValues.rowData?.uid === row?.uid ? false : true,
                modName: modValues.rowData?.uid === row?.uid ? "" : "edit",
                rowData: modValues.rowData?.uid === row?.uid ? "" : row,
                isMap: false,
              }))
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M3.62891 17.3603V20.3254C3.62891 20.5985 3.84349 20.8131 4.1166 20.8131H7.08175C7.20855 20.8131 7.33535 20.7643 7.42313 20.6668L18.0743 10.0254L14.4166 6.36775L3.77521 17.0091C3.67768 17.1067 3.62891 17.2237 3.62891 17.3603ZM20.9029 7.19682C20.9933 7.10658 21.065 6.9994 21.114 6.88141C21.1629 6.76341 21.1881 6.63692 21.1881 6.50918C21.1881 6.38143 21.1629 6.25495 21.114 6.13695C21.065 6.01896 20.9933 5.91177 20.9029 5.82154L18.6205 3.53915C18.5302 3.44873 18.4231 3.37699 18.3051 3.32805C18.1871 3.2791 18.0606 3.25391 17.9328 3.25391C17.8051 3.25391 17.6786 3.2791 17.5606 3.32805C17.4426 3.37699 17.3354 3.44873 17.2452 3.53915L15.4603 5.32409L19.1179 8.98176L20.9029 7.19682Z"
                fill="url(#paint0_linear_14023_4477)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_14023_4477"
                  x1="3.62891"
                  y1="11.6344"
                  x2="21.1881"
                  y2="11.6344"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.0447915" stopColor="#B4000B" />
                  <stop offset="1" stopColor="#DD0000" />
                </linearGradient>
              </defs>
            </svg>
          </button>
          <button
            type="button"
            className="actionBtn icon delete"
            onClick={() => {
              const filters = {
                uid: row?.uid || "",
              };
              handleDelete(filters);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M8.49846 4.3041H11.4978C11.4978 3.90637 11.3398 3.52492 11.0585 3.24369C10.7773 2.96245 10.3958 2.80445 9.99811 2.80445C9.60038 2.80445 9.21893 2.96245 8.9377 3.24369C8.65646 3.52492 8.49846 3.90637 8.49846 4.3041ZM7.4987 4.3041C7.4987 3.64121 7.76203 3.00548 8.23076 2.53675C8.69949 2.06802 9.33522 1.80469 9.99811 1.80469C10.661 1.80469 11.2967 2.06802 11.7655 2.53675C12.2342 3.00548 12.4975 3.64121 12.4975 4.3041H17.4963C17.6289 4.3041 17.7561 4.35676 17.8498 4.45051C17.9435 4.54425 17.9962 4.6714 17.9962 4.80398C17.9962 4.93655 17.9435 5.0637 17.8498 5.15745C17.7561 5.25119 17.6289 5.30386 17.4963 5.30386H16.4426L15.2489 15.6454C15.1645 16.3764 14.8143 17.0509 14.265 17.5405C13.7156 18.0302 13.0054 18.3007 12.2696 18.3008H7.72664C6.99077 18.3007 6.2806 18.0302 5.73125 17.5405C5.18191 17.0509 4.83173 16.3764 4.74735 15.6454L3.55363 5.30386H2.49988C2.3673 5.30386 2.24016 5.25119 2.14641 5.15745C2.05267 5.0637 2 4.93655 2 4.80398C2 4.6714 2.05267 4.54425 2.14641 4.45051C2.24016 4.35676 2.3673 4.3041 2.49988 4.3041H7.4987ZM8.99834 8.30315C8.99834 8.17057 8.94568 8.04343 8.85193 7.94968C8.75819 7.85593 8.63104 7.80327 8.49846 7.80327C8.36588 7.80327 8.23874 7.85593 8.14499 7.94968C8.05125 8.04343 7.99858 8.17057 7.99858 8.30315V14.3017C7.99858 14.4343 8.05125 14.5615 8.14499 14.6552C8.23874 14.7489 8.36588 14.8016 8.49846 14.8016C8.63104 14.8016 8.75819 14.7489 8.85193 14.6552C8.94568 14.5615 8.99834 14.4343 8.99834 14.3017V8.30315ZM11.4978 7.80327C11.3652 7.80327 11.238 7.85593 11.1443 7.94968C11.0505 8.04343 10.9979 8.17057 10.9979 8.30315V14.3017C10.9979 14.4343 11.0505 14.5615 11.1443 14.6552C11.238 14.7489 11.3652 14.8016 11.4978 14.8016C11.6303 14.8016 11.7575 14.7489 11.8512 14.6552C11.945 14.5615 11.9976 14.4343 11.9976 14.3017V8.30315C11.9976 8.17057 11.945 8.04343 11.8512 7.94968C11.7575 7.85593 11.6303 7.80327 11.4978 7.80327Z"
                fill="black"
              />
            </svg>
          </button>
          {/* <button
            className="actionBtn icon map"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isMap: modValues.rowData?.uid === row?.uid ? false : true,
                modName: modValues.rowData?.uid === row?.uid ? "" : "map_gym",
                rowData: modValues.rowData?.uid === row?.uid ? "" : row,
                isEdit: false,
              }))
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-view-list"
              viewBox="0 0 16 16"
            >
              <path d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2m0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14" />
            </svg>
          </button> */}
        </div>
      ),
    },
  ];

  return (
    <div className="createNewCTOModalContainer">
      <CommonHeadingNBtns
        title={`Manage ${rowData?.city || ""} Locations`}
        onClose={closeModal}
        noBtnTxt={true}
        isLoading={postPutLoading}
      />

      <div className="form-container">
        <form className="formContainer">
          <div className="formInputsGrid fourGridSystem">
            <div className="formInputBox">
              <input
                type="text"
                placeholder="Enter Location Name"
                className={`formInput`}
                name="locationName"
                value={formValues.locationName}
                onChange={onChangeInput}
              />
            </div>

            <div
              className={`commonWrapper commonSwitchWrapper no-border minHeight60px`}
              style={{ width: "auto" }}
            >
              <Form.Check
                type="switch"
                name="isActive"
                label={`${formValues.isActive ? "Active" : "Not Active"}`}
                checked={formValues.isActive}
                onChange={onChangeInput}
              />
            </div>

            <div className="formButtons flexStart minHeight60px">
              <button
                type="button"
                className="btn btn-danger btn-save"
                style={{
                  cursor: !formValues.locationName ? "not-allowed" : "pointer",
                }}
                onClick={() => onSubmit("add")}
                disabled={!formValues.locationName ? true : false}
              >
                {modValues.isEdit ? "Update Location" : "Add New Location"}
              </button>
            </div>
          </div>

          {modValues.isMap && (
            <div className="formInputsGrid fourGridSystem">
              <div className="formInputBox">
                <input
                  type="text"
                  className={`formInput`}
                  name="location"
                  value={modValues.rowData?.location || ""}
                  disabled
                />
              </div>

              <div className="formInputBox">
                <div className={`commonWrapper`}>
                  <SelectDropdown
                    options={gymData?.length > 0 ? gymData : []}
                    selectedOption={formValues.selectedGym}
                    setSelectedOption={(selectedValue) =>
                      setFormValues((prevs) => ({
                        ...prevs,
                        selectedGym: selectedValue,
                      }))
                    }
                    name="Gym"
                  />
                </div>
              </div>

              <div className="formButtons flexStart minHeight60px">
                <button
                  type="button"
                  className="btn btn-danger btn-save"
                  style={{
                    cursor: !formValues.selectedGym ? "not-allowed" : "pointer",
                  }}
                  onClick={() => onSubmit("map")}
                  disabled={!formValues.selectedGym ? true : false}
                >
                  Map with gym
                </button>
              </div>
            </div>
          )}
        </form>
      </div>

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt15">
        {gymCityLocationLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allGymLocations}
            tableColumns={tbColumns}
          />
        )}
      </div>
    </div>
  );
};

export default MappedGyms;
